import {IconController} from '../controllers';

Hop.defineModule('svg-icon', (root, param) => {
    const ctrl = new IconController(root, param);

    ctrl.initialize();

    return function destroy() {
        ctrl.destroy();
    };
});
